import {groupRights} from "@services/current-rights.service";
import {guard} from "@/app/routes/guards/guard-factory";

export const guardSportsEdit = guard(groupRights.Sports)('edit')
export const guardSportsWatch = guard(groupRights.Sports)('watch')
export const guardSportsCreate = guard(groupRights.Sports)('create')

